import { Injectable } from "@angular/core";
import { FeeValueConfig } from "@models/configs/fee-value-config";
import BaseApiService from "@shared/services/base/base-api.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ConfigApiService extends BaseApiService {
  getPaymentUrl(): Observable<string> {
    return this.api.get(`${ this.apiUrl }/configs/payment-url`, { responseType: 'text' });
  }

  getFeeValueConfig(): Observable<FeeValueConfig> {
    return this.api.get<FeeValueConfig>(`${ this.apiUrl }/configs/fee`);
  }
}
